import { AnalyticsAction, AnalyticsActionSubject } from '../../types';
import { BaseInvitePeopleAnalytics } from '../../analytics';

export class DropdownMenuAnalytics extends BaseInvitePeopleAnalytics {
	dropdownMenuItemClicked(
		analyticsContext: {
			actionSubjectId?: string;
			attributes?: {};
		} = { attributes: {} },
	): void {
		this.fireUI({
			action: AnalyticsAction.CLICKED,
			actionSubject: AnalyticsActionSubject.DROPDOWN_ITEM,
			actionSubjectId: analyticsContext.actionSubjectId,
			attributes: analyticsContext.attributes,
		});
	}
}
